type SearchType = 'for-sale' | 'to-rent' | 'new-homes';

export function getSearchType(path: string): SearchType {
    const nonForSaleMatches = path.match(/to-rent|new-homes/);

    switch (nonForSaleMatches?.[0]) {
        case 'to-rent':
            return 'to-rent';
        case 'new-homes':
            return 'new-homes';
        default:
            return 'for-sale';
    }
}
